/**
 * Global composable to make all ion-content scrollable regions keyboard accessible
 * This fixes WCAG 2 AA scrollable-region-focusable violations
 */
export function useAccessibleScrolling() {
	if (import.meta.server) return

	const makeContentScrollable = (contentElement: HTMLIonContentElement) => {
		const shadowRoot = contentElement.shadowRoot
		if (!shadowRoot) return false

		const scrollElement = shadowRoot.querySelector('.inner-scroll')
		if (!scrollElement) return false

		// Check if already made accessible
		if (scrollElement.getAttribute('tabindex') === '0') return true

		// Add tabindex to make it keyboard focusable
		scrollElement.setAttribute('tabindex', '0')
		// Add aria-label for screen readers
		scrollElement.setAttribute('aria-label', 'Scrollbarer Inhaltsbereich')

		return true
	}

	const processAllContent = () => {
		const allContent = document.querySelectorAll('ion-content')
		allContent.forEach((content) => {
			makeContentScrollable(content as HTMLIonContentElement)
		})
	}

	// Use MutationObserver to watch for new ion-content elements
	const observer = new MutationObserver(() => {
		processAllContent()
	})

	onMounted(() => {
		// Process existing content
		processAllContent()

		// Watch for new content being added
		observer.observe(document.body, {
			childList: true,
			subtree: true,
		})

		// Also check periodically for the first second (for lazy-loaded components)
		const interval = setInterval(processAllContent, 100)
		setTimeout(() => clearInterval(interval), 2000)
	})

	onUnmounted(() => {
		observer.disconnect()
	})
}
